import {
  getRequirementId,
  isRequirementRef,
  toRequirementRef,
} from '../../../../../util/servicePrincipalRequirement.util'
import { isServicePrincipalInput } from '../../policy_feature/inputs'
import useNameFieldRequirements, {
  buildNameRequirementOptionsMap,
  getAutoModeNameInputs,
} from '../NameRequirements/useNameFieldRequirements'

// ServicePrincipalsInMyTenant is not a ref, so editing the attached requirements keeps it on the
// field.
const SERVICE_PRINCIPAL_REFS = {
  isInput: isServicePrincipalInput,
  isRequirementRef,
  getRequirementId,
  toRequirementRef,
}

export const getAutoModeServicePrincipalInputs = (policyBody) =>
  getAutoModeNameInputs(policyBody, SERVICE_PRINCIPAL_REFS)

export const buildServicePrincipalRequirementOptionsMap = (values) =>
  buildNameRequirementOptionsMap(values, SERVICE_PRINCIPAL_REFS)

export default function useServicePrincipalFieldRequirements({ initialPolicyBody, setPolicyBody }) {
  return useNameFieldRequirements({ initialPolicyBody, setPolicyBody, refs: SERVICE_PRINCIPAL_REFS })
}
